module.exports = __webpack_public_path__ + "img/Companyicon.62ed1a7a.png";